exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stats{display:flex;min-height:100%}.stats__display{width:0;flex:1 1 auto;padding:30px;display:flex;flex-direction:column;justify-content:center}.stats__sidebar{flex:0 0 300px;border-left:1px solid #ffa81d;color:#ffa81d;padding:30px;display:flex;flex-direction:column}.stats__input-row{margin-bottom:50px}.stats__input-row .react-datepicker-wrapper,.stats__input-row .react-datepicker__input-container{display:block}.stats__input-row.form-row.item{flex:1}.stats.input-date{width:100%;display:block}.select_dropdown{max-height:400px}", ""]);

// exports
